import { describe, it, expect, beforeAll, afterAll } from 'vitest';
import { startMcpServer } from './mcp';
import fetch from 'node-fetch';
import http from 'http';

let server: http.Server;
const PORT = 7789;
const BASE_URL = `http://localhost:${PORT}`;

beforeAll(() => {
  server = startMcpServer(PORT);
});

afterAll(() => {
  server.close();
});

describe('MCP API', () => {
  it('should return describe with codn_ref tool', async () => {
    const res = await fetch(`${BASE_URL}/mcp/describe`);
    expect(res.status).toBe(200);
    const json = await res.json();
    expect(Array.isArray(json.tools)).toBe(true);
    const refTool = json.tools.find((t: any) => t.id === 'codn_ref');
    expect(refTool).toBeTruthy();
    expect(refTool.parameters).toHaveProperty('symbol');
  });

  it('should call codn_ref and return symbol reference', async () => {
    const body = {
      jsonrpc: '2.0',
      id: 'test1',
      method: 'codn_ref',
      params: {
        project: '.',
        symbol: 'analyzeProjectReferences',
        includeExternal: false,
        maxDepth: 2,
        caseSensitive: false
      }
    };
    const res = await fetch(`${BASE_URL}/mcp/rpc`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    expect(res.status).toBe(200);
    const json = await res.json();
    expect(json.result).toBeDefined();
    expect(Array.isArray(json.result)).toBe(true);
    expect(json.result[0]?.symbol).toBe('analyzeProjectReferences');
  }, 30000);

  it('should return error for unknown method', async () => {
    const body = {
      jsonrpc: '2.0',
      id: 'err1',
      method: 'not_exist',
      params: {}
    };
    const res = await fetch(`${BASE_URL}/mcp/rpc`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    expect(res.status).toBe(200);
    const json = await res.json();
    expect(json.error).toBeDefined();
  });
}); 